// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import {
  dashboardLocationPreferencesRequested,
  dashboardLocationPreferencesRequestFailed,
  dashboardLocationPreferencesRequestSucceeded,
  filterChanged,
  listVisibilityToggled,
} from './dashboard-location-preferences.actions';
import { LocationPreferencesResponse } from '../services/location-preferences.response';

export const STATE_NAME = 'dashboard-location-preferences';

export interface State {
  isLoading: boolean;
  isError: boolean;
  locationPreferencesResponse: LocationPreferencesResponse;
  filter: string;
  showList: boolean;
}

const initialState: State = {
  isLoading: false,
  isError: false,
  locationPreferencesResponse: undefined,
  filter: undefined,
  showList: true,
};

const reducer = createReducer(
  initialState,
  on(dashboardLocationPreferencesRequested, (state) => ({
    ...state,
    locationPreferencesResponse: undefined,
    isLoading: true,
    isError: false,
    filter: undefined,
  })),
  on(dashboardLocationPreferencesRequestSucceeded, (state, {locationPreferencesResponse}) => {
    const filter = locationPreferencesResponse.clientLocationPreferences.length > 0
      ? locationPreferencesResponse.clientLocationPreferences[0].location.name
      : '';
    return {
      ...state,
      locationPreferencesResponse,
      isLoading: false,
      filter,
    };
  }),
  on(dashboardLocationPreferencesRequestFailed, (state) => ({...state, isLoading: false, isError: true})),
  on(filterChanged, (state, {filter}) => ({...state, filter})),
  on(listVisibilityToggled, (state, {value}) => ({...state, showList: value})),
);

export function dashboardLocationPreferencesReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}
